export default __webpack_public_path__ + "static/media/clock.20cf5789.png";